export default __webpack_public_path__ + "static/media/12-SunsetWalk.e3f30ddb.jpeg";